// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__32z1W"};